export default __webpack_public_path__ + "static/media/about-image-2.f9c86466.jpg";